import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
	// LOCAL
	// private baseUrl: string = 'http://asusx550c:8003/api/superadmin';
	// DEV
	// private baseUrl: string = 'http://mean4-HP-Laptop-15s-du3xxx:8001';//'http://app.guildist.com:8001/api/superadmin';
	// ALPHA-ONE
	// private baseUrl: string = 'https://alpha.novagems.io/api/superadmin';
	// BETA-ONE
	// private baseUrl: string = 'https://app.novagems.io/api/superadmin';
	// private systemAnalyticsApis:string= 'https://analyticsb1.novagems.io/v1/admin';
	// private payrollUpdateBaseUrl:string = 'https://betaone.novagems.io/api/superadmin/';
	// ALPHA-TWO
	// private baseUrl: string = 'https://alphatwo.novagems.io/api/superadmin';

	// BETA-TWO
	// private baseUrl: string = 'https://betatwo.novagems.io/api/superadmin';
	// private systemAnalyticsApis:string = 'https://analyticsb2.novagems.io/v1/admin';
	// private payrollUpdateBaseUrl:string = 'https://betatwo.novagems.io/api/superadmin/';
	// HOTFIX
	// private baseUrl: string = 'https://hotfix.novage.ms/api/superadmin';
	// LIVE
	private newBaseUrl: string = environment.apiURL.newBaseUrl
	private baseUrl: string = environment.apiURL.baseUrl;// 'https://app.novage.ms/api/superadmin';
	private systemAnalyticsApis: string = environment.apiURL.systemAnalyticsApis+'/v1/admin'; //'https://analyticslive.novage.ms/v1/admin';
	private payrollUpdateBaseUrl: string = environment.apiURL.apinode18+'/v1';
	private cliendUrl = environment.apiURL.apinode18;
	private serverUrl: string = environment.apiURL.serverUrl;
	constructor(private http: HttpClient) { }

	private getHeaders() {
		let headers = new HttpHeaders();
		headers.append('Accept', 'application/json');
		return headers;
	}

	// private getHeadersWithKey() {
	// 	let headers = new HttpHeaders();
	// 	const firstTimeLogin_token = sessionStorage.getItem('firstTimeLogin_token');
	// 	const change_password_token = sessionStorage.getItem('change_password_token');
	// 	const access_token_nv_admin = sessionStorage.getItem('access_token_nv_admin');
	// 	// console.log('change_password_token===>', JSON.stringify(change_password_token), '--change_password_token');
	// 	console.log('access_token_nv_admin===>', JSON.stringify(access_token_nv_admin), '--access_token_nv_admin');
	// 	headers.append('Accept', 'application/json');
	// 	if (firstTimeLogin_token && firstTimeLogin_token != '' && firstTimeLogin_token != null) {
	// 		headers.append('Authorization', `Bearer ${firstTimeLogin_token}`);
	// 	} else if (change_password_token && change_password_token != '' && change_password_token != null) {
	// 		headers.append('Authorization', `Bearer ${change_password_token}`);
	// 	} else {
	// 		headers.set('Authorization', `Bearer ${access_token_nv_admin}`);
	// 	}
	// 	console.log('headers===>', JSON.stringify(headers), '--headers');
	// 	return headers;
	// }

	getHeadersWithKey(){
		let authToken = '';
		const firstTimeLogin_token = sessionStorage.getItem('firstTimeLogin_token');
		const change_password_token = sessionStorage.getItem('change_password_token');
		const access_token_nv_admin = sessionStorage.getItem('access_token_nv_admin');
		if (firstTimeLogin_token && firstTimeLogin_token != '' && firstTimeLogin_token != null) {
			authToken = firstTimeLogin_token;
		} else if (change_password_token && change_password_token != '' && change_password_token != null) {
			authToken = change_password_token
		} else {
			authToken = access_token_nv_admin
		}
		let headers = new HttpHeaders({
            'Accept': 'application/json',
            'Authorization': `Bearer ${authToken}`
        })
        return headers;
	}
	login(userName: string, password: string) {
		return this.http
			.post(`${this.baseUrl}/login`, { userName: userName, password: password }, { headers: this.getHeaders() })
			.map(res => res);
	}

	createAccount(name: string, username: string, email: string, password: string) {
		return this.http
			.post(`${this.baseUrl}/createAccount`, { name: name, userName: username, email: email, password: password }, { headers: this.getHeaders() })
			.map(res => res);
	}

	logout(access_token_nv_admin: string) {
		return this.http
			.put(`${this.baseUrl}/logout`, { access_token_nv_admin: access_token_nv_admin }, { headers: this.getHeadersWithKey() })
			.map(res => res);
	}

	forgetPassword(userName: string) {
		return this.http
			.post(`${this.baseUrl}/forgotPassword`, { userName: userName }, { headers: this.getHeaders() })
			.map(res => res);
	}

	resendOTP(userName: string) {
		return this.http
			.put(`${this.baseUrl}/resendOTP`, { userName: userName }, { headers: this.getHeaders() })
			.map(res => res);
	}

	changePassword(password: string) {
		return this.http
			.put(`${this.baseUrl}/changePassword`, { newPassword: password }, { headers: this.getHeadersWithKey() })
			.map(res => res);
	}

	resetCompanyPassword(companyId: string, password: string) {
		return this.http
			.put(`${this.baseUrl}/resetCompanyPassword`, { companyId: companyId, password: password }, { headers: this.getHeadersWithKey() })
			.map(res => res);
	}

	checkOtp(userName: string, otp: string) {
		return this.http
			.post(`${this.baseUrl}/checkOTP`, { userName: userName, generatedOTP: otp }, { headers: this.getHeaders() })
			.map(res => res);
	}
	
	getAllCompanies(params:any) {
		return this.http
			.post(`${this.baseUrl}/getAllCompanies`, params, { headers: this.getHeadersWithKey() })
			.map(res => res);
	}

	// searchCompanies(name: string, limit: number, skip: number) {
	// 	return this.http
	// 		.get(`${this.baseUrl}/getAllCompanies?name=` + name + `&limit=` + limit + `&skip=` + skip, { headers: this.getHeadersWithKey() })
	// 		.map(res => res);
	// }

	getCompany(company_id: string) {
		return this.http
			.get(`${this.baseUrl}/getCompany?companyId=` + company_id, { headers: this.getHeadersWithKey() })
			.map(res => res);
	}

	addCompany(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/addCompany`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	updateCompany(formData: FormData) {
		return this.http
			.put(`${this.baseUrl}/updateCompany`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	updateCompanyPackage(company_id: string, activeUsersCount: string, billingCycleDate: string, isTestingCompany: boolean) {
		return this.http
			.put(`${this.baseUrl}/updateCompanyPackage`, { companyId: company_id, activeUsersCount: activeUsersCount, billingCycleDate: billingCycleDate, isTestingCompany: isTestingCompany }, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	getActiveGuardCounts(company_id: string, startDate: string, endDate: string) {
		return this.http
			.get(`${this.newBaseUrl}/getActiveUserCounts?companyId=` + company_id + `&startDate=` + startDate + `&endDate=` + endDate, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	getActiveGuardCountsBulk(company_id: string, startDate: string, endDate: string) {
		return this.http
			.get(`${this.newBaseUrl}/getActiveUserCountsBulk?companyId=` + company_id + `&startDate=` + startDate + `&endDate=` + endDate, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	updateSendToNovagems(company_id: string, sendBillingToNovagems: boolean) {
		return this.http
			.put(`${this.baseUrl}/updateCompanySendTo`, { companyId: company_id, sendBillingToNovagems: sendBillingToNovagems }, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	updateSendToClient(company_id: string, sendBillingToClient: boolean) {
		return this.http
			.put(`${this.baseUrl}/updateCompanySendTo`, { companyId: company_id, sendBillingToClient: sendBillingToClient }, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisablePatrol(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/togglePatrol`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableDispatch(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleDispatch`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableChat(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleChat`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableDashboard(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleDashboard`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableOpenShift(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleOpenShift`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableScheduleEnhancement(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleScheduleEnhancement`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	enableDisableClockInOut(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/toggleClockInOut`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	linkPartnerAgency(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/linkPartnerAgency`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	unlinkPartnerAgency(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/unlinkPartnerAgency`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	fetchNonPartnerDispatchEnabledAgencies(formData: FormData) {
		return this.http
			.post(`${this.baseUrl}/fetchNonPartnerDispatchEnabledAgencies`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}

	// /**** System analytics apis ********/

	getAllCompanyDetails() {
		return this.http
			.get(`${this.systemAnalyticsApis}/getAllCompanyDetails`, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}
	getOneCompanyData(params) {
		return this.http
			.get(`${this.systemAnalyticsApis}/getOneCompanyData`, { headers: this.getHeadersWithKey(), params })
			.map((res: Response) => res)
	}

	// /*********** apis to update payroll */
	updatePayrollData(formData) {
		return this.http
			.post(`${this.payrollUpdateBaseUrl}/payroll/recalculatePayrolls`, formData, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}
    // /****App Version ********/
    getVersion() {
		return this.http
			.get(`${this.systemAnalyticsApis}/getVersion`, { headers: this.getHeadersWithKey() })
			.map((res: Response) => res)
	}
    updateVersion(params) {
		return this.http
			.put(`${this.systemAnalyticsApis}/updateVersion`,params, { headers: this.getHeadersWithKey()})
			.map((res: Response) => res)
	}

	uploadVideos(params){
		return this.http.post(this.cliendUrl + 'Learning/addVideos', params, { headers: this.getHeadersWithKey() })
		.map((res: Response) => res)
	}
	
	uploadImageArray(data){
        return  this.http
            .post(this.serverUrl + 'common/upload', data, { headers: this.getHeadersWithKey()})
            .map((res: Response) => res)
	
    }

	deleteVideo(param) {
		return this.http.put(this.cliendUrl + 'Learning/deleteVideos', param, { headers: this.getHeadersWithKey() })
		.map((res: Response) => res)
	}

	UpdateVideo(param) {
		return this.http.put(this.cliendUrl + 'Learning/updateVideos', param, { headers: this.getHeadersWithKey() })
		.map((res: Response) => res)
	}

	gettutorialData(tabtype){
        return this.http
        .get(this.cliendUrl + 'Learning/getSuperAdminVideos?type=' + tabtype,{headers: this.getHeadersWithKey() })
        .map((res: Response) => res)
    }
	gettutorialall(){
        return this.http
        .get(this.cliendUrl + 'Learning/getSuperAdminVideos' ,{headers: this.getHeadersWithKey() })
        .map((res: Response) => res)
    }

	updateorder(param){
		return this.http.put(this.cliendUrl + 'Learning/updateOrder', param, { headers: this.getHeadersWithKey() })
		.map((res: Response) => res)
	}

	activityLog(params){
		return this.http.post(this.cliendUrl + 'activityLog/list', params, { headers: this.getHeadersWithKey() })
		.map((res: Response) => res)
	}

	activityLogSites(params){
		return this.http
        .get(this.cliendUrl + 'superAdmin/getAllCompanySites?companyId=' + params.companyId ,{headers: this.getHeadersWithKey() })
        .map((res: Response) => res)
	}

	activityLogsTypes()
	{
		console.log(this.cliendUrl + 'activityLog/listTypes')
		return this.http
		.get(this.cliendUrl + 'activityLog/listTypes',{headers: this.getHeadersWithKey() })
		.map((res:Response)=>res)
	}
}


// WEBPACK FOOTER //
// ./src/app/services/api.service.ts